import {cmps} from './constantes'

const {
   validacion: {esCorreoValido}
} = require('lib.common');

export const esquemaCampos = {
   [cmps.CLIENTE]: {valor: null, error: ''},
   [cmps.RAZON_SOCIAL]: {valor: '', error: ''},
   [cmps.OBSERVACIONES]: {valor: '', error: ''}
};

export const esquemaValidacion = {
   [cmps.CLIENTE]: {
      requerido: true
   },
   [cmps.RAZON_SOCIAL]: {
      requerido: true
   },
   [cmps.OBSERVACIONES]: {
      requerido: true
   }
};